import { render, staticRenderFns } from "./postSubComment.vue?vue&type=template&id=e977589a"
import script from "./postSubComment.vue?vue&type=script&lang=js"
export * from "./postSubComment.vue?vue&type=script&lang=js"
import style0 from "./postSubComment.vue?vue&type=style&index=0&id=e977589a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports